<template>
  <div v-if="show" class="work-experience-page">
    <div class="work-experience-list">
      <div v-for="(workExperience, index) in workExperienceList" class="work-experience" :key="index">
        <WorkExperienceEditor
          ref="workExperience"
          :workExperience="workExperience"
          :index="index"
          :isMiniResume="isMiniResume"
          :resumeEditorSetting="resumeEditorSetting"
          :countryOptions="countryOptions"
          :provinceOptions="workExperienceProvinceOptions[index]"
          :cityOptions="workExperienceCityOptions[index]"
          :jobFamilyOptions="jobFamilyOptions"
          :industryOptions="industryOptions"
          :currencyOptions="currencyOptions"
          :salaryOptions="salaryOptions"
          @load="changeLoading"
          @country-change="handlerCountryChange($event, workExperienceProvinceOptions, workExperienceCityOptions, index)"
          @province-change="handlerProvinceChange($event, workExperienceCityOptions, index)"
        />
        <van-button class="delete-btn" @click="deleteWorkExperience(index)">
          <van-icon class="delete-icon iconfont iconRemove"></van-icon>
          <span>{{ $t(`${i18nPrefix}.editor.workExperience.title.deleteWorkExperience`) }}</span>
        </van-button>
        <van-cell class="delete-border"></van-cell>
      </div>
      <van-button class="add-btn" @click="addWorkExperience">
        <van-icon class-prefix="add-icon iconfont iconAdd1"></van-icon>
        <span>{{ $t(`${i18nPrefix}.editor.workExperience.title.addWorkExperience`) }}</span>
      </van-button>
      <van-cell class="add-border"></van-cell>
    </div>

    <div class="part-time-experience-list">
      <div v-for="(partTimeExperience, index) in partTimeExperienceList" class="part-time-experience" :key="index">
        <WorkExperienceEditor
          ref="partTimeExperience"
          :workExperience="partTimeExperience"
          :index="index"
          :isMiniResume="isMiniResume"
          :resumeEditorSetting="resumeEditorSetting"
          :countryOptions="countryOptions"
          :provinceOptions="partTimeProvinceOptions[index]"
          :cityOptions="partTimeCityOptions[index]"
          :jobFamilyOptions="jobFamilyOptions"
          :industryOptions="industryOptions"
          :currencyOptions="currencyOptions"
          :salaryOptions="salaryOptions"
          @load="changeLoading"
          @country-change="handlerCountryChange($event,  partTimeProvinceOptions, partTimeCityOptions, index)"
          @province-change="handlerProvinceChange($event, partTimeCityOptions, index)"
        />
        <van-button class="delete-btn" @click="deletePartTimeExperience(index)">
          <van-icon class="delete-icon iconfont iconRemove"></van-icon>
          <span>{{ $t(`${i18nPrefix}.editor.partTimeExperience.title.deleteWorkExperience`) }}</span>
        </van-button>
        <van-cell class="delete-border"></van-cell>
      </div>
      <van-button class="add-btn" @click="addPartTimeExperience">
        <van-icon class-prefix="add-icon iconfont iconAdd1"></van-icon>
        <span>{{ $t(`${i18nPrefix}.editor.partTimeExperience.title.addWorkExperience`) }}</span>
      </van-button>
      <van-cell class="add-border"></van-cell>
    </div>

    <van-dialog
      v-model="dialog.show"
      class="delete-dialog"
      show-cancel-button
      :title="dialog.title"
      :confirm-button-text="$t('common.btn.confirm')"
      :cancel-button-text="$t('common.btn.cancel')"
      @confirm="onConfirm"
      @cancel="onCancel"
    >
      {{ dialog.content || $t('common.message.confirmDelete') }}
    </van-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import WorkExperienceEditor from '@/components/candidate/mobile/workExperience.vue'
import { addI18nProperty } from '@/i18n'
import { STEP_TYPE } from '@/constant/candidate'
import mixin from './mixin'
import moment from 'moment'

export default {
  mixins: [mixin],
  components: {
    WorkExperienceEditor
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      partTimeExperienceList: [],
      workExperienceList: [],
      countryOptions: [],
      // 将每个工作经历对应的province 与 city保存，当下一次回到该页面时不需要重新获取数据
      workExperienceProvinceOptions: [],
      workExperienceCityOptions: [],
      partTimeProvinceOptions: [],
      partTimeCityOptions: [],
      jobFamilyOptions: [],
      industryOptions: [],
      currencyOptions: [],
      salaryOptions: [],
      dialog: {
        show: false,
        content: null,
        title: null,
        confirm: null,
        cancel: null
      }
    }
  },
  computed: {
    isMiniResume () {
      return this.resumeEditorSetting?.isMiniResume
    },
    isBasicResume () {
      return this.resumeEditorSetting?.isBasicResume
    },
    workExperienceSetting () {
      return this.resumeEditorSetting?.[STEP_TYPE.WORK_EXPERIENCE] || {}
    },
    hiddenMiniResumeField () {
      const hidden = []
      if (this.workExperienceSetting.isMiniResume) {
        const workCount = this.data.workExperience?.length
        const partTimeCount = this.data.workExperience?.length
        if (workCount || partTimeCount) {
          _.times(_.max([workCount, partTimeCount]), index => {
            hidden.push(true)
          })
        }
      }
      return hidden
    }
  },
  created () {
    this.initData()
  },
  mounted () {},
  methods: {
    ...mapActions('common', ['getCurrencyList']),
    ...mapActions('application', ['getIndustryList', 'getJobFamilyList', 'getSalaryList']),
    ...mapActions('worldLocation', ['getCountryList', 'getProvinceList', 'getCityList']),
    async initData () {
      this.$emit('load', true)
      try {
        await Promise.all([
          this.loadJobFamilyList(),
          this.loadCountryList(),
          this.loadIndustryList(),
          this.loadCurrencyList(),
          this.loadSalaryList()
        ])
      } finally {
        this.$emit('load', false)
      }
    },
    async submit (isPrevious) {
      let workExperienceForm = null
      let partTimeExperienceForm = null
      if (this.show) {
        workExperienceForm = this.$refs.workExperience
        partTimeExperienceForm = this.$refs.partTimeExperience
        if (!workExperienceForm) {
          await this.$nextTick()
          workExperienceForm = this.$refs.workExperience
          partTimeExperienceForm = this.$refs.partTimeExperience
        }
      }
      let validate = true
      if (partTimeExperienceForm) {
        const partTimeExperienceLength = partTimeExperienceForm.length
        await Promise.all(_.times(partTimeExperienceLength, async (index) => {
          const result = await partTimeExperienceForm[partTimeExperienceLength - 1 - index].submit()
          if (!result) {
            if (isPrevious) {
              this.partTimeExperienceList.splice(partTimeExperienceLength - 1 - index, 1)
            } else {
              validate = false
            }
          }
        }))
      }
      if (workExperienceForm) {
        const workExperienceLength = workExperienceForm.length
        await Promise.all(_.times(workExperienceLength, async (index) => {
          const result = await workExperienceForm[workExperienceLength - 1 - index].submit()
          if (!result) {
            if (isPrevious) {
              this.workExperienceList.splice(workExperienceLength - 1 - index, 1)
            } else {
              validate = false
            }
          }
        }))
      }
      const workCount = this.workExperienceSetting.workCount
      if (!isPrevious && validate && workCount && this.workExperienceList.length < workCount) {
        this.$toast({ message: this.$t(`${this.i18nPrefix}.message.workCountRequired`) })
        validate = false
      }
      _.sortBy(this.partTimeExperienceList, item => item.startDate ? moment(item.startDate).valueOf() : Infinity)
      _.sortBy(this.workExperienceList, item => item.startDate ? moment(item.startDate).valueOf() : Infinity)

      return validate
    },
    async loadCountryList () {
      const resp = await this.getCountryList()
      if (resp) {
        this.countryOptions = this.formatSimpleJobInfo(resp.location_list)
      }
    },
    async loadProvinceList (countryId, provinceOptions, cityOptions, index) {
      if (countryId) {
        const params = {
          parentId: countryId
        }
        const resp = await this.getProvinceList(params)
        if (resp) {
          this.$set(provinceOptions, index, this.formatSimpleJobInfo(resp.location_list))
        }
      } else {
        this.$set(provinceOptions, index, [])
        this.$set(cityOptions, index, [])
      }
    },
    async loadCityList (provinceId, cityOptions, index) {
      if (provinceId) {
        const params = {
          parentId: provinceId
        }
        const resp = await this.getCityList(params)
        if (resp) {
          this.$set(cityOptions, index, this.formatSimpleJobInfo(resp.location_list))
        }
      } else {
        this.$set(cityOptions, index, [])
      }
    },
    async loadJobFamilyList () {
      const resp = await this.getJobFamilyList()
      if (resp) {
        this.jobFamilyOptions = _.map(resp.job_family_list, (item) => {
          item.value = `${item.id}`
          addI18nProperty(item, 'label', 'cn_name', 'en_name')
          return item
        })
      }
    },
    async loadIndustryList () {
      const resp = await this.getIndustryList()
      if (resp) {
        this.industryOptions = this.formatSimpleJobInfo(resp.industry_list)
      }
    },
    async loadCurrencyList () {
      return this.getCurrencyList().then(resp => {
        if (!resp) {
          return []
        }
        const currencyOptions = _.map(resp, (item) => {
          return { id: item.id, label: `${item.name}(${item.value})`, value: item.name }
        })
        this.currencyOptions = currencyOptions
      })
    },
    async loadSalaryList () {
      const resp = await this.getSalaryList()
      if (resp) {
        this.salaryOptions = this.formatSimpleJobInfo(resp.salary_list)
      }
    },
    async handlerCountryChange (event, provinceOptions, cityOptions, index) {
      const countryId = event.countryId
      const callback = event.callback
      this.$set(provinceOptions, index, [])
      this.$set(cityOptions, index, [])
      await this.loadProvinceList(countryId, provinceOptions, cityOptions, index)
      callback && callback()
    },
    async handlerProvinceChange (event, cityOptions, index) {
      const provinceId = event.provinceId
      const callback = event.callback
      this.$set(cityOptions, index, [])
      await this.loadCityList(provinceId, cityOptions, index)
      callback && callback()
    },
    addWorkExperience () {
      const workExperience = this.initFormData()
      this.workExperienceList.push(workExperience)
      this.workExperienceProvinceOptions.push([])
      this.workExperienceCityOptions.push([])
    },
    deleteWorkExperience (index) {
      const workCount = this.workExperienceSetting.workCount
      if (workCount && this.workExperienceList.length <= workCount) {
        this.$toast({ message: this.$t(`${this.i18nPrefix}.message.workCountRequired`) })
        return
      }
      this.dialog.show = true
      this.dialog.confirm = () => {
        this.workExperienceList.splice(index, 1)
        this.workExperienceProvinceOptions.splice(index, 1)
        this.workExperienceCityOptions.splice(index, 1)
      }
    },
    addPartTimeExperience () {
      const workExperience = this.initFormData()
      this.partTimeExperienceList.push(workExperience)
      this.partTimeProvinceOptions.push([])
      this.partTimeCityOptions.push([])
    },
    deletePartTimeExperience (index) {
      this.dialog.show = true
      this.dialog.confirm = () => {
        this.partTimeExperienceList.splice(index, 1)
        this.partTimeProvinceOptions.splice(index, 1)
        this.partTimeCityOptions.splice(index, 1)
      }
    },
    onConfirm () {
      this.dialog.confirm && this.dialog.confirm()
      this.dialog.show = false
      this.dialog.confirm = null
      this.dialog.cancel = null
    },
    onCancel () {
      this.dialog.cancel && this.dialog.cancel()
      this.dialog.show = false
      this.dialog.confirm = null
      this.dialog.cancel = null
    },
    changeLoading (loading) {
      this.$emit('load', loading)
    },
    initFormData () {
      return {
        companyName: null,
        jobTitle: null,
        jobFamily: null,
        industry: null,
        country: null,
        province: null,
        city: null,
        startDate: null,
        endDate: null,
        currency: null,
        salary: null,
        summary: null
      }
    },
    formatSimpleJobInfo (info) {
      return _.chain(info)
        .filter(item => (item.cn_name && item.name))
        .map(item => {
          const info = {
            ...item,
            value: item.id || item.value
          }
          addI18nProperty(info, 'label', 'cn_name', 'name')
          return info
        })
        .value()
    },
    async getStepData () {
      const workExperienceInfo = this.data
      this.partTimeExperienceList = workExperienceInfo?.partTimeExperience || []
      _.forEach(this.partTimeExperienceList, (item, index) => {
        item.jobFamily = parseInt(item.jobFamily) || null
        this.partTimeProvinceOptions.push([])
        this.partTimeCityOptions.push([])
      })
      this.workExperienceList = workExperienceInfo?.workExperience || []
      _.forEach(this.workExperienceList, (item, index) => {
        item.jobFamily = parseInt(item.jobFamily) || null
        this.workExperienceProvinceOptions.push([])
        this.workExperienceCityOptions.push([])
      })
    }
  },
  watch: {
    show: {
      immediate: true,
      async handler () {
        if (this.show) {
          await this.getStepData()
          await this.$nextTick()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.work-experience-page {
  padding: 20px 18px 0;

  .delete-btn {
    margin: 12px 0 12px;
    display: block;
    height: 36px;
    width: 100%;
    background: #fff;
    color: #909399;
    border: none;

    .delete-icon {
      display: inline-block;
      line-height: 16px;
      font-size: 16px;
      margin-right: 6px;
    }

    ::v-deep {

      .van-button__text {
        display: flex;
        text-align: center;
        color: #606266;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  .delete-border {
    padding: 0;
    margin-bottom: 12px;
    border-bottom: 1px solid #dcdfe6;
  }

  .add-border {
    padding: 0;
    margin-bottom: 12px;
    border-bottom: 1px solid #dcdfe6;
  }

  .add-btn {
    margin: 12px 0 12px;
    display: block;
    height: 36px;
    width: 100%;
    background: #fff;
    color: var(--custom-color, #0096cc);
    border: none;

    .add-icon {
      display: inline-block;
      line-height: 16px;
      font-size: 16px;
      margin-right: 6px;
    }

    ::v-deep {

      .van-button__text {
        display: flex;
        text-align: center;
        color: var(--custom-color, #0096cc);
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  .delete-dialog {
    ::v-deep {
      .van-dialog__content {
        padding: 20px;
        text-align: center;
      }

      .van-dialog__confirm {
        .van-button__text {
          color: var(--custom-color, #0096cc);
        }
      }
    }
  }
}
</style>
